module.exports = __webpack_public_path__ + "img/nasjonalramme.0a2f0c9f.jpg";